// extracted by mini-css-extract-plugin
module.exports = {"iconLink":"site-footer_iconLink_MLngP","siteFooter":"site-footer_siteFooter_30EE2"};